module.exports = "<p>redirect works!</p>\n"